import { toJalaali } from 'jalaali-js';

function convertTimestampToShamsi(timestamp: number): string {
  const newTimeStamp = timestamp * 1000;
  const date = new Date(newTimeStamp);
  // Extract the Gregorian year, month, and day from the Date object
  const gregorianYear = date.getFullYear();
  const gregorianMonth = date.getMonth() + 1; // getMonth() is zero-indexed, so we add 1
  const gregorianDay = date.getDate();

  // Convert the Gregorian date to a Shamsi (Jalaali) date
  const shamsiDate = toJalaali(gregorianYear, gregorianMonth, gregorianDay);

  // Format the Shamsi date as 'YYYY/MM/DD'
  const formattedShamsiDate = `${shamsiDate.jy}/${String(shamsiDate.jm).padStart(2, '0')}/${String(shamsiDate.jd).padStart(2, '0')}`;

  return formattedShamsiDate;
}

export default convertTimestampToShamsi;
